import { defineAsyncComponent } from 'vue';
const resultSync = defineAsyncComponent(() => import('@/views/enactDictionary/syncDictionary/popup/ResultSyncPopup.vue'));
const notificationSync = defineAsyncComponent(() => import('@/views/enactDictionary/syncDictionary/popup/NotificationSyncDictionary.vue'));
const patternRegularExplanationViewPopup = defineAsyncComponent(() => import('@/views/enactDictionary/syncDictionary/popup/PatternRegularExplanationViewPopup.vue'));
const resultItemDelete = defineAsyncComponent(() => import('@/views/enactDictionary/syncDictionary/popup/ResultItemDeletePopup.vue'));
const mergeContent = defineAsyncComponent(() => import('@/views/enactDictionary/syncDictionary/popup/MergeContentPopup.vue'));

export function syncDictionary(app) {
    app.component('ResultSyncPopup', resultSync);
    app.component('NotificationSyncDictionaryPopup', notificationSync);
    app.component('PatternRegularExplanationViewPopup', patternRegularExplanationViewPopup);
    app.component('ResultItemDeletePopup', resultItemDelete);
    app.component('MergeContentPopup', mergeContent);
}



